import { useEffect } from 'react';
import Wrapper from '@/components/wrapper';
import { getServerSideProps, getHead } from '@/utils/useHead';

export { getServerSideProps }

export default ({ menuDetail }: any) => {
  useEffect(() => {
    setTimeout(() => {
      const str = document.getElementById("reactCode")?.innerText || 'console.log()';
      eval(str)
    }, 0);
  }, [menuDetail]);
  return (
    <div>
      <Wrapper>
        <>
          {getHead(menuDetail)}
          <div className="m-1600" dangerouslySetInnerHTML={{ __html: menuDetail?.info?.content }} />
        </>
      </Wrapper>
    </div>
  );
};
